import {useEffect, useState} from "react";
import style from "./input.module.scss";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const Input = (props) => {
    const [active, setActive] = useState(false);
    const [type, setType] = useState(props.type);


    const handleBlur = (e) => {
        if (!e.currentTarget.value) {
            setActive(false);
        }
    };

    const handlerTypes = () => {
        setType(type === "password" ? "text" : "password");
    }

    return (
        // <div className={[style.row, props.class].join(" ")}>
        <div className={[
            style.input,
            active && style.active,
            props.class,
            props.error && style.error
        ].join(" ")}>
            {props.title && (<label htmlFor={props.id}>{props.title}</label>) || ""}
            <div className={style.rowInput}>

                <input
                    id={props.id}
                    name={props.name}
                    type={type}
                    value={props.value}
                    onChange={props.handleChange}
                    onFocus={() => setActive(true)}
                    onBlur={handleBlur}
                    placeholder={props.placeholder}
                />
                {/*autoComplete="new-password"*/}

                {props.type === 'password' && (
                    <div onClick={handlerTypes} className={style.eye}>
                        {type === "text" ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </div>
                )}
            </div>
            {props.errorMessage && (<div className={style.errorMessage}>{props.errorMessage}</div>) || ""}
        </div>
        // </div>

    )
};

export default Input;